/* @flow */

import React, { useState, useCallback } from 'react';
import { Button } from '@sonyged/ext-proc';
import LoadingIcon from '../../assets/images/pages/top/loading@3x.png';

const makeButton = (variant: string) => {
  const ButtonComponent = Button[variant];

  const LoadingButton = ({ onClick, className = '', disabled, children, ...rest }: any) => {
    const [clicked, setClicked] = useState(false);
    const handleClick = useCallback(
      e => {
        setClicked(true);
        if (onClick) onClick(e);
      },
      [setClicked, onClick]
    );

    return (
      <ButtonComponent
        {...rest}
        onClick={handleClick}
        className={clicked ? `proc-button--loading ${className}` : className}
        disabled={clicked ? true : disabled}
      >
        {clicked ? (
          <img alt="loading icon" className="proc-button-icon proc-button-loadingIcon" src={LoadingIcon} />
        ) : (
          children
        )}
      </ButtonComponent>
    );
  };

  return LoadingButton;
};

const buttonVariants = ['normal', 'attention', 'dark', 'light', 'primary'];
export default buttonVariants.reduce((obj, variant) => {
  obj[variant] = makeButton(variant);
  return obj;
}, {});
